export default __webpack_public_path__ + "static/media/image2.f8bc1f02.png";